<template>
  <modal
      id="package-list-modal"
      size="large"
      v-model="showModal"
      :title="from === 'user' ? generateModalTitle('user') : generateModalTitle('Package')"
      @submit="submit"
      :loading="loading"
      :btn-label="selectedUrl ? $t('save') : $t('add')"
      :preloader="preloader">

    <form
        v-if="(isMailSettingExist || selectedUrl) && !preloader"
        ref="form"
        :data-url='selectedUrl ? selectedUrl : GET_ALL_PACKAGES'
        @submit.prevent="submitData"
    >
      <div class="row">
        <div class="col-md-6">
          <app-form-group
              :label="$t('name')"
              :placeholder="$placeholder('name')"
              v-model="formData.name"
              :required="true"
              :error-message="$errorMessage(errors, 'name')"
          />
        </div>
        <div class="col-md-3">
            <app-form-group
                :label="$t('price')"
                :placeholder="$placeholder('price')"
                v-model="formData.price"
                :required="true"
                :error-message="$errorMessage(errors, 'price')"
            />
        </div>
        <div class="col-md-3">
            <app-form-group
                :label="$t('upgrade_price')"
                :placeholder="$placeholder('upgrade_price')"
                v-model="formData.upgrade_price"
                :required="true"
                :error-message="$errorMessage(errors, 'upgrade_price')"
            />
        </div>
        <div class="col-md-6">
<!--          <app-form-group-selectable-->
<!--              :label="$t('billing_cycle')"-->
<!--              :placeholder="$placeholder('billing_cycle')"-->
<!--              v-model="formData.billing_cycle"-->
<!--              :required="true"-->
<!--              :error-message="$errorMessage(errors, 'billing_cycle')"-->
<!--          />-->
          <app-form-group
              type="select"
              :label="$t('billing_cycle')"
              :list="billingOptions"
              list-value-field="label"
              list-key-field="id"
              v-model="formData.billing_cycle"
              :error-message="$errorMessage(errors, 'billing_cycle')"
          />
        </div>
        <div class="col-md-6">
          <app-form-group
              :label="$t('user_limit')"
              :placeholder="$placeholder('user_limit')"
              v-model="formData.user_limit"
              :required="true"
              :error-message="$errorMessage(errors, 'user_limit')"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <app-form-group
              type="number"
              :label="$t('location_limit')"
              :placeholder="$placeholder('input_location_limit')"
              v-model="formData.location_limit"
              :required="true"
              :error-message="$errorMessage(errors, 'location_limit')"
          />
        </div>
        <div class="col-md-6">
          <app-form-group
              type="number"
              :label="$t('trial_period')"
              :placeholder="$placeholder('trial_period_default')"
              v-model="formData.trial_period"
              :required="true"
              :error-message="$errorMessage(errors, 'trial_period')"
          />
        </div>
      </div>

      <div class="row d-flex flex-row align-items-center w-full"
           v-for="(feature, index) in formData.package_feature"
           :key="index"
      >
        <div class="col-md-10">
          <app-form-group
              :label="`Feature ${index + 1}`"
              :placeholder="$placeholder('features')"
              v-model="formData.package_feature[index].feature"
              :required="true"
              :error-message="$errorMessage(errors, 'package_feature')"
          />
        </div>
        <div class="col-md-2">
          <i class="fa fa-plus-circle btn-outline-success rounded-pill cursor-pointer p-2" @click="addFeature"></i>
          <i class="fa fa-minus-circle btn-outline-danger rounded-pill cursor-pointer p-2" @click="removeFeature"></i>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
<!--          <app-form-group-->
<!--              :label="$t('status')"-->
<!--              type="radio"-->
<!--              :list="[-->
<!--                {id:'active',value: $t('status_active')},-->
<!--                {id:'inactive', value:  $t('status_inactive')},-->
<!--            ]"-->
<!--              v-model="formData.status"-->
<!--              :error-message="$errorMessage(errors, 'status')"-->
<!--              name="status"-->
<!--          />-->
          <label>
            <span>{{ $t('status') }}</span>
          </label>
          <app-input
              type="radio"
              :label="$t('status')"
              v-model="formData.status"
              :list="[
                {id:'active',value: $t('status_active')},
                {id:'inactive', value:  $t('status_inactive')},
            ]"
              :error-message="$errorMessage(errors, 'status')"
              list-value-field="value"/>
        </div>
        <div class="col-md-6">
          <app-form-group
              :label="$t('featured')"
              id="featured"
              type="radio"
              :list="[
                {id:'yes',value: $t('yes')},
                {id:'no', value:  $t('no')},
              ]"
              v-model="formData.featured"
              :error-message="$errorMessage(errors, 'featured')"
              name="featured"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <app-form-group
              type="multi-select"
              :label="$t('modules')"
              v-if="true"
              :list="moduleList"
              list-label-field="id"
              list-value-field="label"
              v-model="formData.modules"
              chooseLabel="Modules"
              :isAnimatedDropdown="true"
              :error-message="$errorMessage(errors, 'modules')"
              :loading="false"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <app-form-group
              type="textarea"
              :label="$t('description')"
              :placeholder="$placeholder('description')"
              v-model="formData.description"
              :required="true"
              :error-message="$errorMessage(errors, 'description')"
          />
        </div>
      </div>

    </form>

    <template v-if="!isMailSettingExist && !selectedUrl" slot="footer">
      <button type="button"
              class="btn btn-secondary"
              data-dismiss="modal">
        {{ $t('close') }}
      </button>
    </template>
  </modal>
</template>

<script>
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import {
  GET_ALL_PACKAGES,
} from "../../../Config/ApiUrl";
import {
  TENANT_MAIL_CHECK_URL,
} from "../../../../common/Config/apiUrl";
import {axiosGet} from "../../../../common/Helper/AxiosHelper";
import LogMixin from "../../Mixins/LogMixin";
import {addChooseInSelectArray} from "../../../../common/Helper/Support/FormHelper";

export default {
  name: "PackageCreateEditModal",
  mixins: [FormHelperMixins, ModalMixin, LogMixin],
  props: {
    from: {
      type: String,
      default: 'package'
    },
    subPackage: {
      type: Object,
      default: null
    },
    // subscriptionPackage: {
    //   type: {},
    //   default: null
    // },
    loaderColor: {
      type: String,
      default: 'white-color'
    }
  },
  data() {
    return {
      maps: null,
      isMailSettingExist: true,
      preloader: false,
      loading: false,
      // features: [],
      billingOptions: [
        { id: 'monthly', label: 'Monthly' },
        { id: 'yearly', label: 'Yearly' }
      ],
      // default_modules: ["job_desk","employee","attendance","leave","administration","payroll","location","asset"],
      moduleList: [
        // {label: 'Job Desk', id: 'job_desk'},
        {label: 'Employee', id: 'employee'},
        {label: 'Location', id: 'location'},
        {label: 'Attendance', id: 'attendance'},
        {label: 'Leave', id: 'leave'},
        {label: 'Administration', id: 'administration'},
        {label: 'Assets', id: 'assets'},
      ],
      formData: {
        name: "Test",
        description: "test",
        price: 100,
        upgrade_price: 50,
        billing_cycle: "monthly",
        features: [],
        user_limit: 10,
        location_limit: 2,
        status: "active",
        package_type: "",
        featured: "no",
        trial_period: 15,
        package_feature: [],
        modules: [],
      },
      GET_ALL_PACKAGES,
    }
  },
  methods: {
    addFeature() {
      // this.formData.package_feature.push('');
      this.formData.package_feature.push({
        subscription_package_id: this.formData.id || null,
        feature: ''
      });
    },
    removeFeature(index) {
      // this.formData.features.splice(index, 1);
      this.formData.package_feature.splice(index, 1);
    },
    submit() {
      // console.log(this.formData);
      // this.formData.modules = JSON.stringify(this.formData.modules);
      // this.formData.features = this.features;
      this.fieldStatus.isSubmit = true;
      // this.formData.duration = parseInt(this.formData.duration);
      // this.formData.modules = JSON.stringify(this.formData.modules);
      this.loading = true;
      this.message = '';
      this.errors = {};
      // this.formData.alias = formatDateForServer(this.formData.contract_start_date);
      this.submitData(this.formData);
    },
    afterSuccess({data}) {
      this.formData = {};
      $('#package-list-modal').modal('hide');
      this.$emit('input', false);
      this.toastAndReload(data.message, this.from === 'package' ? 'package-table' : 'user-table');
      if (this.from === 'user') {
        this.$hub.$emit(`reload-role-table`)
      }
    },
    afterSuccessFromGetEditData({data}) {
      // this.formData.modules = JSON.parse(data.modules);
      // console.log(data);
      // this.arrays = addChooseInSelectArray(data.modules, 'modules', this.$t('modules'));
      this.formData = {
        ...this.formData,
        ...data,
        // modules: data.modules.map(moduleId => {
        //   return this.moduleList.find(module => module.id === moduleId);
        // })
      };
      // this.formData.modules = this.arrays[1];
      // console.log(this.formData.modules);

      // this.formData = {...this.formData, ...data};

    },
    checkMailSettings() {
      this.preloader = true;
      axiosGet(TENANT_MAIL_CHECK_URL).then(response => {
        this.isMailSettingExist = !!response.data;
      }).finally(() => {
        this.preloader = false;
      });
    },
    generateModalTitle(subject) {
      return this.$fieldTitle(this.selectedUrl ? 'edit' : 'add', subject, true);
    },
  },
  created() {
    this.addFeature();
    if (this.selectedUrl) {
      // this.formData = this.subPackage;
      // this.checkEmployeeID();
      // this.features = JSON.parse(this.features);
    }
    else {
      this.addFeature();
    }
  },
  watch: {
    'formData.modules': {
      handler: function(value) {
        if (JSON.stringify(value) !== JSON.stringify(this.formData.modules)) {
          this.formData = {
            ...this.formData,
            modules: value
          };
        }
        this.preloader = false;
      },
      deep: true
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    }
  },
  mounted() {},
}
</script>